import React from "react";

import { OptisignsAssetBrowser } from "@/components/editor/optisigns-assets-panel/optisigns-asset-browser";
import { type OptisignsAssetRefSelection } from "@/components/editor/optisigns-assets-panel/use-optisigns-assets";

interface OptisignsAssetResultsHITLProps {
  /** Project the chat belongs to — the browser fetches its OptiSigns assets. */
  projectId?: string;
  /** Folder the agent surfaced (seeds the in-card browser; null = root). */
  path?: string | null;
  summary: string;
  /** Hand the picked assets to the composer as @asset chips. */
  onAddToMessage: (refs: OptisignsAssetRefSelection[]) => void;
}

/**
 * Inline chat HITL for OptiSigns asset discovery (`optisigns_asset_results`).
 * A live browser (card variant of {@link OptisignsAssetBrowser}): folders open
 * in place via direct fetch (no agent turn) and "Add to message" drops the
 * picks into the composer as @asset chips instead of starting a new turn.
 */
export function OptisignsAssetResultsHITL({
  projectId,
  path,
  summary,
  onAddToMessage,
}: OptisignsAssetResultsHITLProps): React.ReactElement {
  return (
    <OptisignsAssetBrowser
      variant="card"
      projectId={projectId}
      initialPath={path}
      summary={summary}
      onAddToMessage={onAddToMessage}
    />
  );
}
